import * as React from 'react';

const Facebook = ({
  fill = '#4A4F4A',
  width = '24',
  height = '24'
}: React.SVGProps<SVGSVGElement>) => (
  <svg width="38" height="39" viewBox="0 0 38 39" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.686157" width="38" height="38" rx="19" fill="#616161" />
    <path d="M28.0002 19.6454C28.0002 14.6974 23.9708 10.6862 19.0002 10.6862C14.0297 10.6862 10.0002 14.6974 10.0002 19.6454C10.0002 24.1172 13.2914 27.8238 17.594 28.4959V22.2352H15.3088V19.6454H17.594V17.6716C17.594 15.4262 18.9377 14.1859 20.9934 14.1859C21.9778 14.1859 23.0081 14.3609 23.0081 14.3609V16.5657H21.8732C20.7552 16.5657 20.4065 17.2564 20.4065 17.9656V19.6454H22.9026L22.5036 22.2352H20.4065V28.4959C24.7091 27.8238 28.0002 24.1172 28.0002 19.6454Z" fill="#EAEAEA" />
  </svg>
);

export default Facebook;
